import React, { useState } from 'react';
import { Button, Card, Row, Col, Container } from 'react-bootstrap';
import InvoiceTemplate from './IncoiceTemplate';

const InvoiceTemplateDemo = () => {
    const [selectedInvoice, setSelectedInvoice] = useState(null);

    // Sample invoice data
    const sampleInvoices = [
        {
            id: 19722,
            type: 'Invoice',
            client: {
                name: 'John Doe',
                email: 'john.doe@example.com',
                avatar: ''
            },
            invoice_items: [
                {
                    id: 1,
                    description: 'Premium Package',
                    package: 'Premium Package',
                    quantity: 1,
                    tax_percentage: 18,
                    tax_amount: 50.00,
                    amount: 50.00,
                    total_amount: 50.00
                },
                {
                    id: 2,
                    description: 'Premium Package 2',
                    package: 'Premium Package 2',
                    quantity: 1,
                    tax_percentage: 18,
                    tax_amount: 500.00,
                    amount: 500.00,
                    total_amount: 500.00
                },
                {
                    id: 3,
                    description: 'Premium Package 3',
                    package: 'Premium Package 3',
                    quantity: 1,
                    tax_percentage: 18,
                    tax_amount: 5000.00,
                    amount: 5000.00,
                    total_amount: 5000.00
                }
            ],
            package: 'Premium Package',
            createdDate: 'April 23, 2025',
            tax_amount: 5000.00,
            total_amount: 5000.00,
            amount: 5000.00,
            status: 'Pending',
            dueDate: 'May 23, 2025',
            description: 'Medical consultation and treatment package'
        },
        {
            id: 19723,
            type: 'Receipt',
            client: {
                name: 'Jane Smith',
                email: 'jane.smith@example.com',
                avatar: ''
            },
            invoice_items: [
                {
                    id: 1,
                    description: 'Basic Package',
                    package: 'Basic Package',
                    quantity: 1,
                    tax_percentage: 18,
                    tax_amount: 25.00,
                    amount: 25.00,
                    total_amount: 25.00
                }
            ],
            package: 'Basic Package',
            createdDate: 'April 22, 2025',
            tax_amount: 25.00,
            total_amount: 2500.00,
            amount: 2500.00,
            status: 'Paid',
            dueDate: 'May 22, 2025',
            description: 'Basic medical consultation'
        },
        {
            id: 19724,
            type: 'Invoice',
            client: {
                name: 'Mike Johnson',
                email: 'mike.johnson@example.com',
                avatar: ''
            },
            invoice_items: [
                {
                    id: 1,
                    description: 'Deluxe Package',
                    package: 'Deluxe Package',
                    quantity: 1,
                    tax_percentage: 18,
                    tax_amount: 100.00,
                    amount: 100.00,
                    total_amount: 100.00
                },
                {
                    id: 2,
                    description: 'Deluxe Package 2',
                    package: 'Deluxe Package 2',
                    quantity: 1,
                    tax_percentage: 18,
                    tax_amount: 1000.00,
                    amount: 1000.00,
                    total_amount: 1000.00
                }
            ],
            package: 'Deluxe Package',
            createdDate: 'April 21, 2025',
            tax_amount: 100.00,
            total_amount: 1000.00,
            amount: 1000.00,
            status: 'Overdue',
            dueDate: 'April 21, 2025',
            description: 'Comprehensive medical package with follow-up'
        }
    ];

    const customCompanyInfo = {
        name: "MeddyList Healthcare Solutions",
        address: "456 Healthcare Boulevard",
        city: "Delhi, Delhi 110001",
        country: "India",
        phone: "+91 98765 43210",
        email: "billing@meddylist.com",
        website: "www.meddylist.com",
        logo: ""
    };

    const handleDownload = (invoice) => {
        console.log('Downloading invoice:', invoice);
        // Custom download logic can be implemented here
    };

    const handleEmail = (invoice) => {
        console.log('Emailing invoice:', invoice);
        // Custom email logic can be implemented here
    };

    const handleView = (invoice) => {
        console.log('Viewing invoice:', invoice);
        // Custom view logic can be implemented here
    };

    const handleDelete = (invoiceId) => {
        console.log('Deleting invoice:', invoiceId);
        // Custom delete logic can be implemented here
    };

    return (
        <Container className="py-4">
            <div className="mb-4">
                <h2>Invoice Template Demo</h2>
                <p className="text-muted">This demonstrates the reusable InvoiceTemplate component with different configurations.</p>
            </div>

            <Row className="mb-4">
                <Col md={12}>
                    <Card>
                        <Card.Header>
                            <h5>Sample Invoices</h5>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                {sampleInvoices.map((invoice) => (
                                    <Col md={4} key={invoice.id} className="mb-3">
                                        <Card 
                                            className={`cursor-pointer ${selectedInvoice?.id === invoice.id ? 'border-primary' : ''}`}
                                            onClick={() => setSelectedInvoice(invoice)}
                                        >
                                            <Card.Body className="text-center">
                                                <h6>Invoice #{invoice.id}</h6>
                                                <p className="mb-1">{invoice.client.name}</p>
                                                <p className="text-muted small">{invoice.package}</p>
                                                <p className="fw-bold text-primary">₹{invoice.amount}</p>
                                                <Button 
                                                    size="sm" 
                                                    variant={selectedInvoice?.id === invoice.id ? "primary" : "outline-primary"}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedInvoice(invoice);
                                                    }}
                                                >
                                                    {selectedInvoice?.id === invoice.id ? 'Selected' : 'Select'}
                                                </Button>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {selectedInvoice && (
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Header>
                                <h5>Invoice Template - {selectedInvoice.client.name}</h5>
                            </Card.Header>
                            <Card.Body>
                                <InvoiceTemplate
                                    invoice={selectedInvoice}
                                    invoice_items={selectedInvoice.invoice_items}
                                    showActions={true}
                                    showPreview={true}
                                    onDownload={handleDownload}
                                    onEmail={handleEmail}
                                    onView={handleView}
                                    onDelete={handleDelete}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}

            <Row className="mt-4">
                <Col md={12}>
                    <Card>
                        <Card.Header>
                            <h5>Usage Examples</h5>
                        </Card.Header>
                        <Card.Body>
                            <div className="mb-3">
                                <h6>Basic Usage:</h6>
                                <pre className="bg-light p-3 rounded">
{`<InvoiceTemplate 
    invoice={invoiceData} 
/>`}
                                </pre>
                            </div>
                            
                            <div className="mb-3">
                                <h6>With Custom Company Info:</h6>
                                <pre className="bg-light p-3 rounded">
{`<InvoiceTemplate 
    invoice={invoiceData}
    invoice_items={invoiceData.invoice_items}
    companyInfo={{
        name: "Your Company",
        address: "Your Address",
        city: "Your City",
        country: "Your Country",
        phone: "Your Phone",
        email: "Your Email"
    }}
/>`}
                                </pre>
                            </div>
                            
                            <div className="mb-3">
                                <h6>With Custom Actions:</h6>
                                <pre className="bg-light p-3 rounded">
{`<InvoiceTemplate 
    invoice={invoiceData}
    invoice_items={invoiceData.invoice_items}
    showActions={true}
    showPreview={true}
    onDownload={handleDownload}
    onEmail={handleEmail}
    onView={handleView}
    onDelete={handleDelete}
/>`}
                                </pre>
                            </div>
                            
                            <div className="mb-3">
                                <h6>Read-only Mode:</h6>
                                <pre className="bg-light p-3 rounded">
{`<InvoiceTemplate 
    invoice={invoiceData}
    invoice_items={invoiceData.invoice_items}
    showActions={false}
    showPreview={false}
/>`}
                                </pre>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default InvoiceTemplateDemo;
